import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, withKeys as _withKeys, createVNode as _createVNode, resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createElementBlock as _createElementBlock } from "vue"
import _imports_0 from '@/assets/sos-logo.png'


const _hoisted_1 = { class: "logging-bg flex h-screen w-screen p-4" }
const _hoisted_2 = { class: "flex flex-col-reverse md:flex-row shadow-xl rounded-lg m-auto overflow-hidden" }
const _hoisted_3 = { class: "bg-white py-4 px-10 md:w-94 flex flex-col gap-2 items-center justify-center" }
const _hoisted_4 = /*#__PURE__*/_createElementVNode("div", null, [
  /*#__PURE__*/_createElementVNode("h4", null, "Crea una nueva contraseña")
], -1)
const _hoisted_5 = { class: "relative" }
const _hoisted_6 = { class: "relative" }
const _hoisted_7 = {
  key: 0,
  class: "text-red-600 text-sm mb-4"
}
const _hoisted_8 = {
  key: 2,
  class: "flex items-center justify-center"
}
const _hoisted_9 = /*#__PURE__*/_createElementVNode("div", { class: "animate-spin rounded-full h-12 w-12 border-t-4 border-b-4 border-primary-500 border-success" }, null, -1)
const _hoisted_10 = [
  _hoisted_9
]
const _hoisted_11 = /*#__PURE__*/_createElementVNode("div", { class: "bg-black bg-opacity-60 p-4 md:w-72 flex flex-col justify-center" }, [
  /*#__PURE__*/_createElementVNode("img", {
    class: "flex",
    src: _imports_0,
    alt: "logo beepi"
  })
], -1)

import { ref } from "vue";
import { useRoute, useRouter } from "vue-router";
import { AuthService } from "@/services/auth/AuthServices";
import { swal as Swal } from "@/configs/swal";

import TextField from "@/components/general/atoms/TextField.vue";
import RecoverAccount from "@/components/communities/molecules/RecoverAccount.vue";
import AppButton from "@/components/general/atoms/AppButton.vue";
import { RecoveryPassword } from "@/services/auth/types";


export default /*#__PURE__*/_defineComponent({
  __name: 'RecoverView',
  setup(__props) {

const route = useRoute();
const router = useRouter();
const authService = new AuthService();
const new_password = ref("");
const confirm_password = ref("");
const hasError = ref(false);
const showPassword = ref(false);
const showConfirmPassword = ref(false);
const loading = ref(false);
const errorMessage = ref("Credenciales inválidas");
const recoverPassword = ref(false);

const showPass = () => {
  showPassword.value = !showPassword.value;
}

const showConfirmPass = () => {
    showConfirmPassword.value = !showConfirmPassword.value;
}

async function login() {
  hasError.value = false;
  loading.value = true;

  const tokenParam = route.params.token;

  const recoveryPassword:RecoveryPassword = {
    token: Array.isArray(tokenParam) ? tokenParam[0] : tokenParam ?? '',
    "new_password": new_password.value,
    "confirm_password": confirm_password.value
  } 

  const response = await authService.recoveryPassword(recoveryPassword);

  loading.value = false;
  if (!response.success) {
    hasError.value = true;
    errorMessage.value = response?.data.detail

    if (response?.data.detail) {
      Swal.fire({
        icon: "error",
        title: "Error",
        text: response?.data.detail,
      });
    }

    return;
  } else {
    Swal.fire({
        icon: "success",
        title: "¡Contraseña actualizada!",
        html: `
            <p>Ya puedes iniciar sesión con tu nueva contraseña.</p>
        `,
        confirmButtonText: "Ir a iniciar sesión",
        confirmButtonColor: "#22c55e", // opcional: color verde por ejemplo
        }).then(() => {
            router.push("/");
        });
  }
}


return (_ctx: any,_cache: any) => {
  const _component_mdicon = _resolveComponent("mdicon")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _hoisted_4,
        _createElementVNode("div", _hoisted_5, [
          _createVNode(TextField, {
            label: "Nueva contraseña",
            model: new_password.value,
            "onUpdate:model": _cache[0] || (_cache[0] = ($event: any) => ((new_password).value = $event)),
            type: showPassword.value ? 'text' : 'password',
            name: "new_password",
            "hide-details": "",
            onKeyup: _cache[1] || (_cache[1] = _withKeys(($event: any) => (login()), ["enter"]))
          }, null, 8, ["model", "type"]),
          _createElementVNode("button", {
            class: "absolute right-2 top-8 rounded-lg bg-primary-600 hover:bg-primary-800 font-bold mx-auto",
            onClick: _cache[2] || (_cache[2] = ($event: any) => (showPass()))
          }, [
            (showPassword.value)
              ? (_openBlock(), _createBlock(_component_mdicon, {
                  key: 0,
                  name: "eye",
                  size: "20"
                }))
              : _createCommentVNode("", true),
            (!showPassword.value)
              ? (_openBlock(), _createBlock(_component_mdicon, {
                  key: 1,
                  name: "eye-remove-outline",
                  size: "20"
                }))
              : _createCommentVNode("", true)
          ])
        ]),
        _createElementVNode("div", _hoisted_6, [
          _createVNode(TextField, {
            label: "Confirmar contraseña",
            model: confirm_password.value,
            "onUpdate:model": _cache[3] || (_cache[3] = ($event: any) => ((confirm_password).value = $event)),
            type: showConfirmPassword.value ? 'text' : 'password',
            name: "confirm_password",
            "hide-details": "",
            onKeyup: _cache[4] || (_cache[4] = _withKeys(($event: any) => (login()), ["enter"]))
          }, null, 8, ["model", "type"]),
          _createElementVNode("button", {
            class: "absolute right-2 top-8 rounded-lg bg-primary-600 hover:bg-primary-800 font-bold mx-auto",
            onClick: showConfirmPass
          }, [
            (showConfirmPassword.value)
              ? (_openBlock(), _createBlock(_component_mdicon, {
                  key: 0,
                  name: "eye",
                  size: "20"
                }))
              : _createCommentVNode("", true),
            (!showConfirmPassword.value)
              ? (_openBlock(), _createBlock(_component_mdicon, {
                  key: 1,
                  name: "eye-remove-outline",
                  size: "20"
                }))
              : _createCommentVNode("", true)
          ])
        ]),
        (hasError.value)
          ? (_openBlock(), _createElementBlock("p", _hoisted_7, _toDisplayString(errorMessage.value), 1))
          : _createCommentVNode("", true),
        (!loading.value)
          ? (_openBlock(), _createBlock(AppButton, {
              key: 1,
              text: "Restablecer contraseña",
              uppercase: false,
              onClick: _cache[5] || (_cache[5] = ($event: any) => (login())),
              class: "bg-green-500 text-white mt-4"
            }))
          : _createCommentVNode("", true),
        (loading.value)
          ? (_openBlock(), _createElementBlock("div", _hoisted_8, _hoisted_10))
          : _createCommentVNode("", true)
      ]),
      _hoisted_11
    ]),
    _createVNode(RecoverAccount, {
      visible: recoverPassword.value,
      "onUpdate:visible": _cache[6] || (_cache[6] = ($event: any) => ((recoverPassword).value = $event))
    }, null, 8, ["visible"])
  ]))
}
}

})